/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import Box from '@mui/material/Box';
import Add from '@mui/icons-material/Add';
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';
import OpenInNew from '@mui/icons-material/OpenInNew';
import PdpQuantityCounter from './pdpQuantityCounter';
import PdpEmail from './pdpEmail';
import PdpPartners from './pdpPartners';
import PdpShopOnline from './pdpShopOnline';
import CustomButton from '../CommonComponents/CustomButton';
import { useNurseryContext } from '../../contexts/NurseryContext';
const classes = {
    notifyMeButton: (theme) => ({
        '&.MuiButton-outlined': {
            marginTop: theme.spacing(2.5),
            marginBottom: theme.spacing(0.9),
            width: '100%',
            height: theme.spacing(6),
            textTransform: 'none',
            fontSize: theme.spacing(1.75),
            fontFamily: 'Arial',
            fontWeight: 'bold',
            border: `1px solid ${theme.palette.primary.dark}`,
            '&:hover': {
                backgroundColor: 'rgba(91, 106, 116, 0.04) !important',
            },
        },
    }),
};
const PdpHeaderShopify = ({ variants, djangoPk = 0, onAddToShopifyCart, title: plantTitle, partnersData, isForSale, affiliatedLinks, staticContext, }) => {
    const { nurserySlug: nurserySlugContext } = useNurseryContext();
    const nurserySlug = staticContext ? staticContext.nurseries : nurserySlugContext;
    const shopifyProduct = nurserySlug
        ? variants === null || variants === void 0 ? void 0 : variants.filter((variant) => variant.fulfillment_service === nurserySlug)
        : variants;
    const filteredLinks = nurserySlug
        ? affiliatedLinks.filter((item) => item.nursery.slug === nurserySlug)
        : affiliatedLinks;
    const selectedServerVariant = shopifyProduct.length > 0
        ? shopifyProduct[0]
        : filteredLinks.length > 0
            ? filteredLinks[0]
            : null;
    const [isNotifyModal, setIsNotifyModal] = useState(false);
    const [openOptions, setOpenOptions] = useState(false);
    const [selectedVariant, setSelectedVariant] = useState(selectedServerVariant);
    const VariantCard = ({ variant }) => {
        const selectedItem = selectedVariant || selectedServerVariant;
        if (selectedItem) {
            const { price, nursery, } = variant;
            const selected = variant.id === selectedItem.id;
            const { shipping_info: shippingInfo, name } = nursery || {};
            const quantity = 'inventory_quantity' in variant
                ? variant.inventory_quantity
                : variant.quantity;
            const title = 'inventory_quantity' in variant
                ? variant.title
                : variant.size;
            const updatedName = name ? `at ${name}` : '';
            const quantityText = quantity < 30
                ? `Fewer than ${quantity} ${updatedName}`
                : `${quantity} ${updatedName}`;
            const isAffiliated = !('handle' in variant);
            return (React.createElement("div", { className: `variant_container ${selected ? 'selected' : ''}` },
                React.createElement("div", { role: "button", onClick: () => {
                        setSelectedVariant(variant);
                    }, className: `shopify_variant_card_wrapper ${selected ? 'selected' : ''}` },
                    React.createElement("div", { className: "shopify_variant_card" },
                        isAffiliated && (!title && !price) ? React.createElement("p", null, name) : (React.createElement("p", null,
                            React.createElement("span", null, title),
                            ' ',
                            "|",
                            ' ',
                            React.createElement("strong", null, "$"),
                            React.createElement("strong", null, price))),
                        React.createElement("p", { className: "shipping_info" }, shippingInfo),
                        isAffiliated && (!title && !price) ? React.createElement(React.Fragment, null) : React.createElement("p", { className: "quantity_text" }, quantityText)))));
        }
        return React.createElement(React.Fragment, null);
    };
    const MoreOptions = () => (React.createElement("div", { role: "button", onClick: () => setOpenOptions(true), className: "variant_container" },
        React.createElement("div", { className: "shopify_variant_card_wrapper more_options_container" },
            React.createElement("div", { className: "shopify_variant_card more_options_container " },
                React.createElement("div", { className: "more_options" },
                    React.createElement(Add, null),
                    React.createElement("p", null, "More Options"))))));
    return (React.createElement("div", { className: "header_shopify" },
        (shopifyProduct === null || shopifyProduct === void 0 ? void 0 : shopifyProduct.length) > 0 || (filteredLinks === null || filteredLinks === void 0 ? void 0 : filteredLinks.length) > 0 ? (React.createElement("div", { className: "header_shopify_container" },
            React.createElement("div", { className: "variants_wrapper" },
                (shopifyProduct === null || shopifyProduct === void 0 ? void 0 : shopifyProduct.length) > 0 && (shopifyProduct === null || shopifyProduct === void 0 ? void 0 : shopifyProduct.map((variant) => (React.createElement(VariantCard, { key: variant.id, variant: variant })))),
                (filteredLinks === null || filteredLinks === void 0 ? void 0 : filteredLinks.length) > 0 && (filteredLinks === null || filteredLinks === void 0 ? void 0 : filteredLinks.map((link) => (React.createElement(VariantCard, { key: link.id, variant: link })))),
                React.createElement(MoreOptions, null)))) : (React.createElement("div", { className: "variants_wrapper notify_container" },
            React.createElement(CustomButton, { onClick: () => {
                    setIsNotifyModal(true);
                    setOpenOptions(true);
                }, variant: "outlined", color: "primary", buttonClassSX: classes.notifyMeButton, buttonText: "Notify me" }),
            (partnersData === null || partnersData === void 0 ? void 0 : partnersData.length) > 0 && React.createElement(MoreOptions, null))),
        (selectedVariant || selectedServerVariant) && isForSale && ('handle' in (selectedVariant || selectedServerVariant)) && (React.createElement(PdpQuantityCounter, { selectedVariant: (selectedVariant || selectedServerVariant), djangoPk: djangoPk, onAddToShopifyCart: onAddToShopifyCart })),
        ((selectedVariant || selectedServerVariant) && !('handle' in (selectedVariant || selectedServerVariant)) && (selectedVariant || selectedServerVariant).sale_url)
            && (React.createElement("a", { target: "_blank", rel: "noopener nofollow sponsored", href: (selectedVariant || selectedServerVariant).sale_url },
                React.createElement("button", { style: {
                        width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 16,
                    }, type: "button", className: "btn primary ", onClick: () => gtag('event', 'buy_from_nursery') },
                    "Buy Direct from Nursery",
                    ' ',
                    React.createElement(OpenInNew, { sx: { padding: 0, marginLeft: 2 } })))),
        React.createElement(Modal, { onClose: () => {
                setIsNotifyModal(false);
                setOpenOptions(false);
            }, open: openOptions },
            React.createElement(Box, { className: `options_modal ${isNotifyModal ? 'notify_me' : ''}` },
                React.createElement("button", { type: "button", onClick: () => {
                        setIsNotifyModal(false);
                        setOpenOptions(false);
                    }, className: "close_btn" },
                    React.createElement(CloseIcon, null)),
                React.createElement(Box, { className: "options_modal_wrapper" },
                    !isNotifyModal
                        && (React.createElement("h1", null,
                            "Find",
                            ' ',
                            plantTitle)),
                    ((isForSale || (affiliatedLinks === null || affiliatedLinks === void 0 ? void 0 : affiliatedLinks.length) > 0) && !isNotifyModal) && (React.createElement(PdpShopOnline, { djangoPk: djangoPk, onAddToShopifyCart: onAddToShopifyCart, variants: variants.filter((item) => item.available), affiliatedLinks: affiliatedLinks })),
                    (partnersData.length > 0 && !isNotifyModal)
                        && React.createElement(PdpPartners, { data: partnersData }),
                    React.createElement("div", { className: "pdp_email_modal" },
                        React.createElement("div", { className: "modal_item_container" },
                            React.createElement(PdpEmail, { isNotifyModal: isNotifyModal, plantId: djangoPk, plantName: plantTitle, closeModal: () => { setIsNotifyModal(false); setOpenOptions(false); } }))))))));
};
export default withRouter(PdpHeaderShopify);
